/**
 * Set location cookie with Canarias Value
 */
(function(){
    const C = {
        cookie:{
            name: 'location',
            value: 'canarias',
            domain: '.mediamarkt.es',
            days: 15,
            sameSite: 'Strict'
        }
    }

    // Set Cookie
    if (!mmkt.core.cookie.getCookie(C.cookie.name)) mmkt.core.cookie.setCookie(C.cookie.name, C.cookie.value, { days: C.cookie.days }, C.cookie.domain, C.cookie.sameSite);
})();